export const endpoints = {
  feedback: {
    search: () => "/api/v1/internal/feedback/search",
    getAllTransitions: () => "/api/v1/internal/feedback/gettransitions",
    quickSearch: () => "/api/v1/internal/feedback/quicksearch",
    autocomplete: () => "/api/v1/internal/search/autocomplete",
    autocompleteSearch: () => "/api/v1/internal/search/autocomplete/feedback",
    getByCode: (code: string) => `/api/v1/internal/feedback/${code}`,
    vote: (code: string) => `/api/v1/internal/feedback/${code}/vote`,
    create: (code: string) => `/api/v1/internal/feedback/${code}`,
    update: (code: string) => `/api/v1/internal/feedback/${code}`,
    delete: (code: string) => `/api/v1/internal/feedback/${code}`,
    state: (code: string) => `/api/v1/internal/feedback/${code}/state`,
    getTransitions: (code: string) => `/api/v1/internal/feedback/${code}/transition`,
    transition: (code: string) => `/api/v1/internal/feedback/${code}/transition`,
    forceState: (code: string) => `/api/v1/internal/feedback/${code}/state/force`,
    priority: (code: string) => `/api/v1/internal/feedback/${code}/priority`,
    dueDate: (code: string) => `/api/v1/internal/feedback/${code}/dueDate`,
    feedbackRelationships: (id: number) =>
      `api/v1/internal/feedback/id/${id}/feedbackrelationships`,
    generateCode: () => "/api/v1/internal/feedback/code",
    getTitle: (code: string) => `/api/v1/internal/feedback/${code}/title`,
    images: {
      uploadTemp: (code: string) => `/api/v1/internal/feedback/images/temp/${code}`,
      deleteTemp: () => "/api/v1/internal/feedback/images/temp"
    },
    files: {
      uploadTemp: (code: string, isCadmakersOnly: boolean) =>
        `/api/v1/internal/feedback/files/temp/${code}?isCadmakersOnly=${isCadmakersOnly}`,
      deleteTemp: () => "/api/v1/internal/feedback/files/temp"
    },
    assignment: {
      assignments: (code: string) => `/api/v1/internal/feedback/${code}/assignedusers`
    }
  },
  comments: {
    create: () => "/api/v1/internal/comments",
    get: (code: string) => `/api/v1/internal/comments/${code}`,
    vote: (id: number) => `/api/v1/internal/comments/${id}/vote`,
    edit: (id: number) => `/api/v1/internal/comments/${id}`,
    delete: (id: number) => `/api/v1/internal/comments/${id}`,
    images: {
      uploadTemp: (id: string | number) => `/api/v1/internal/comments/images/temp/${id}`,
      deleteTemp: () => "/api/v1/internal/comments/images/temp"
    }
  },
  history: {
    search: () => "/api/v1/internal/feedback/history"
  }
};
